const PREFERENCES_MODEL_CLASS_NAME = 'Preferences'

const PREFERENCES_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',

  PUSH_PLAN_START_WORKOUT_DISABLED: 'pushPlanStartWorkoutDisabled',
  NOTIFICATION_MISSED_PLANNED_WORKOUT_DISABLED: 'notificationMissedPlannedWorkoutDisabled',
  NEW_ARTICLE_NOTIFICATION_DISABLED: 'newArticleNotificationDisabled',
  REPORT_NOTIFICATION_DISABLED: 'reportNotificationDisabled',
  LOG_MEAL_REMINDER_DISABLED: 'logMealReminderDisabled',
  FITNESS_SUMMARY_REPORT_DISABLED: 'fitnessSummaryReportDisabled',

  // Creators
  MESSAGE_NOTIFICATION_DISABLED: 'messageNotificationDisabled',
  PURCHASE_NOTIFICATION_DISABLED: 'purchaseNotificationDisabled',
  REVIEW_NOTIFICATION_DISABLED: 'reviewNotificationDisabled',

  TRAINING_TIME: 'trainingTime',
  EQUIPMENT_DATA: 'equipmentData',
  PROFILE_ID: 'profileId'
}

const PREFERENCES_MODEL_PRIVATE_KEYS = []

const PREFERENCES_MODEL_SCOPE = {
  /**
   * Only returns the public attributes of a `Settings`.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: PREFERENCES_MODEL_PRIVATE_KEYS
    }
  }
}

export {
  PREFERENCES_MODEL_PRIVATE_KEYS,
  PREFERENCES_MODEL_KEY,
  PREFERENCES_MODEL_CLASS_NAME,
  PREFERENCES_MODEL_SCOPE
}
